/**
 * Store Context
 * Provides store instance to React components via context
 */

import { createContext, useContext } from 'react';
import type { IStore } from '../types';

/**
 * Store context type
 */
export interface StoreContextValue<State = unknown> {
  store: IStore<State>;
}

/**
 * Store context - uses unknown as default to allow any state type
 */
export const StoreContext = createContext<StoreContextValue<unknown> | null>(null);

/**
 * Hook to access store from context
 */
export function useStoreContext<State = unknown>(): StoreContextValue<State> {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStoreContext must be used within a StoreProvider');
  }
  return context as StoreContextValue<State>;
}
